import { combineReducers } from 'redux';
import counter from './counter';
import cesta from './cesta';

export default combineReducers({
  counter,
  cesta,
});
